import type { Object3D } from 'three'

const ROTATION_SNAP_STEP = Math.PI / 2 // 90°
const ROTATION_SNAP_THRESHOLD = Math.PI / 36 // 5°

export const ROTATION_DRAG_SNAP = Math.PI / 180 // 1°

export function snapRotationToNearestStep(target: Object3D): void {
  const axes = ['x', 'y', 'z'] as const
  for (const axis of axes) {
    const current = target.rotation[axis]
    const nearestStep = Math.round(current / ROTATION_SNAP_STEP) * ROTATION_SNAP_STEP
    if (Math.abs(current - nearestStep) < ROTATION_SNAP_THRESHOLD) {
      target.rotation[axis] = nearestStep
    }
  }
}
